<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="aut"><span class="bold">By the same author</span></p>
<p class="aut1"><em class="italic">Active Goodness: The True Story of How Trevor Chadwick, Doreen Warriner &amp; Nicholas Winton Rescued Thousands from the Nazis</em></p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Author.vue?6c6bc5c3